/* eslint-disable no-unused-expressions */
/* 左边的品牌列表 */
import React, { useRef, useState, useEffect } from 'react'
import classnames from 'classnames'

interface Options {
  param: any
  text: string
  key?: string
}

interface IProps {
  type?: string
  value: any
  options: Options[]
  onChange?: (value: any) => void
}

export default function SingleList({ options, value, onChange, type }: IProps) {
  const [current, setCurrent] = useState(value)

  useEffect(() => {
    setCurrent(value)
  }, [value])

  return (
    <div className="single-list-wrap">
      {options.map((item: Options, index: number) => {
        return (
          <p
            className={classnames('single-child', {
              selected: current == item.param && (!type || type === item?.key),
            })}
            onClick={(event) => {
              event.stopPropagation()
              if (current == item.param) {
                setCurrent('')
                onChange?.({
                  param: 'x',
                  text: '不限',
                })
                return
              }
              setCurrent(item.param)
              onChange?.(item)
            }}
            key={`single-child-${index}`}
          >
            <span className="icon" />
            <span className="single-name">{item.text}</span>
          </p>
        )
      })}
      <style jsx>
        {`
          .single-list-wrap {
            width: 160px;
            text-align: left;
            padding: 10px 0 5px 0;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
            background-color: #ffffff;
            z-index: 100;
          }
          .single-child {
            padding: 8px 20px;
            cursor: pointer;
            display: flex;
          }
          .single-child:hover {
            background-color: #f7f8fc;
          }
          .icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-right: 4px;
            background: url(${require('./static/radio.png')}) no-repeat 0 0 /
              cover;
          }
          .single-name {
            flex: 1;
            line-height: 20px;
          }
          .selected .icon {
            background: url(${require('./static/radio-active.png')}) no-repeat 0
              0 / cover;
          }
        `}
      </style>
    </div>
  )
}
